import { isNil } from "lodash";
import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import { InsightPage } from "@radarly/models/insight-pages/model";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useInsightPage(projectId: number, id: InsightPage["id"]) {
  const isValidId = !isNil(id);
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const { data: page, isLoading: loading } = useQuery(
    ["/insight-page/get", { projectId, id }],
    () => {
      return id ? repository.getInsightPage(projectId, id) : null;
    },
    { enabled: isValidId } // Prevents making a request with an invalid insightPage id
  );
  return {
    loading,
    page: isValidId ? page : null,
  };
}
